import type { WLatestNewsTranslations } from "./pl";

export const en: WLatestNewsTranslations = {
  empty: "No news in this section.",
  readMore: "Read more",
  watchAll: "See all",
  /** `formatDate("2026-05-13")` -> "13 May 2026". */
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
};
